var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"table-box"},[_c('calendar-component')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }